export default {
    SECTION_WIDGET_CONTENT: {
      layout_02:{
          container: {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 2,
                    },
                    66.67: {
                      allow: true,
                      item: 1,
                    },
                    58.33: {
                      allow: true,
                      item: 1,
                    },
                    50: {
                      allow: true,
                      item: 1,
                    },
                    41.67: {
                      allow: true,
                      item: 1,
                    },
                    33.33: {
                      allow: true,
                      item: 1,
                    },
                    25: {
                      allow: false,
                      item: 0,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },
              }
          },
          "container-fluid": {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 2,
                    },
                    66.67: {
                      allow: true,
                      item: 2,
                    },
                    58.33: {
                      allow: true,
                      item: 2,
                    },
                    50: {
                      allow: true,
                      item: 2,
                    },
                    41.67: {
                      allow: true,
                      item: 1,
                    },
                    33.33: {
                      allow: true,
                      item: 1,
                    },
                    25: {
                      allow: false,
                      item: 0,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },

              }
          }
      },
      layout_03:{
          container: {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 3,
                    },
                    66.67: {
                      allow: true,
                      item: 2,
                    },
                    58.33: {
                      allow: true,
                      item: 2,
                    },
                    50: {
                      allow: true,
                      item: 2,
                    },
                    41.67: {
                      allow: true,
                      item: 1,
                    },
                    33.33: {
                      allow: true,
                      item: 1,
                    },
                    25: {
                      allow: true,
                      item: 1,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },
              }
          },
          "container-fluid": {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 3,
                    },
                    66.67: {
                      allow: true,
                      item: 2,
                    },
                    58.33: {
                      allow: true,
                      item: 2,
                    },
                    50: {
                      allow: true,
                      item: 2,
                    },
                    41.67: {
                      allow: true,
                      item: 2,
                    },
                    33.33: {
                      allow: true,
                      item: 2,
                    },
                    25: {
                      allow: true,
                      item: 1,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },

              }
          }
      },
      layout_04:{
          container: {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 1,
                    },
                    66.67: {
                      allow: true,
                      item: 1,
                    },
                    58.33: {
                      allow: true,
                      item: 1,
                    },
                    50: {
                      allow: true,
                      item: 1,
                    },
                    41.67: {
                      allow: false,
                      item: 0,
                    },
                    33.33: {
                      allow: false,
                      item: 0,
                    },
                    25: {
                      allow: false,
                      item: 0,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },
              }
          },
          "container-fluid": {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 1,
                    },
                    66.67: {
                      allow: true,
                      item: 1,
                    },
                    58.33: {
                      allow: true,
                      item: 1,
                    },
                    50: {
                      allow: true,
                      item: 1,
                    },
                    41.67: {
                      allow: false,
                      item: 0,
                    },
                    33.33: {
                      allow: false,
                      item: 0,
                    },
                    25: {
                      allow: false,
                      item: 0,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },

              }
          }
      },
      layout_05:{
          container: {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 1,
                    },
                    66.67: {
                      allow: true,
                      item: 1,
                    },
                    58.33: {
                      allow: true,
                      item: 1,
                    },
                    50: {
                      allow: true,
                      item: 1,
                    },
                    41.67: {
                      allow: true,
                      item: 1,
                    },
                    33.33: {
                      allow: true,
                      item: 1,
                    },
                    25: {
                      allow: false,
                      item: 0,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },
              }
          },
          "container-fluid": {
              cellWidth:{
                  100: {
                      allow: true,
                      item: 1,
                    },
                    66.67: {
                      allow: true,
                      item: 1,
                    },
                    58.33: {
                      allow: true,
                      item: 1,
                    },
                    50: {
                      allow: true,
                      item: 1,
                    },
                    41.67: {
                      allow: true,
                      item: 1,
                    },
                    33.33: {
                      allow: true,
                      item: 1,
                    },
                    25: {
                      allow: false,
                      item: 0,
                    },
                    20: {
                      allow: false,
                      item: 0,
                    },
                    16.66: {
                      allow: false,
                      item: 0,
                    },
              }
          }
      },
      layout_06:{
        container: {
          cellWidth: {
            100: {
              allow: true,
              item: {
                desktop: 3,
                tablet: 2,
                mobile: 1,
              }
            },
            66.67: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            58.33: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            50: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            41.67: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            33.33: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            25: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            20: {
              allow: false,
              item: {
                desktop: null,
                tablet: null,
                mobile: null,
              }
            },
            16.66: {
              allow: false,
              item: {
                desktop: null,
                tablet: null,
                mobile: null,
              }
            },
          },
        },
        'container-fluid': {
          cellWidth: {
            100: {
              allow: true,
              item: {
                desktop: 3,
                tablet: 2,
                mobile: 1,
              }
            },
            66.67: {
              allow: true,
              item: {
                desktop: 2,
                tablet: 1,
                mobile: 1,
              }
            },
            58.33: {
              allow: true,
              item: {
                desktop: 2,
                tablet: 1,
                mobile: 1,
              }
            },
            50: {
              allow: true,
              item: {
                desktop: 2,
                tablet: 1,
                mobile: 1,
              }
            },
            41.67: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            33.33: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            25: {
              allow: true,
              item: {
                desktop: 1,
                tablet: 1,
                mobile: 1,
              }
            },
            20: {
              allow: false,
              item: {
                desktop: null,
                tablet: null,
                mobile: null,
              }
            },
            16.66: {
              allow: false,
              item: {
                desktop: null,
                tablet: null,
                mobile: null,
              }
            },
          },
        },
      },
    }
}